import { MIN_REASONABLE_NUMBER } from '@shared/validation'
import { testIsValidMonetaryValue } from '@ui-common/utils'
import { IntlShape } from 'react-intl'
import { create, Suite } from 'vest'

import { RecommemmendationFormData } from './RecommendationStep'
import { LOAN_OFFER_SAVINGS_MAX_MONTHLY_VALUE } from './recommendationStepUtils'

export const createFormValidator = (
  formatMessage: IntlShape['formatMessage'],
): Suite<string, string, (data: RecommemmendationFormData) => void> => {
  return create((data) => {
    testIsValidMonetaryValue(
      'monthlySavingsAmount',
      data.monthlySavingsAmount,
      formatMessage,
      LOAN_OFFER_SAVINGS_MAX_MONTHLY_VALUE,
      false,
      MIN_REASONABLE_NUMBER,
    )
  })
}
